<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'LinkNavTab'
 * FIGMA: ''
 */
import type { LinkNavTabProps } from '../types/interfaces'

defineOptions({
  name: 'LinkNavTab',
})

withDefaults(defineProps<LinkNavTabProps>(), {
  selected: false,
  disabled: false,
})
</script>

<template>
  <NuxtLink
    :to="to"
    :class="['link-nav-tab', { selected, disabled }]"
  >
    {{ text }}
  </NuxtLink>
</template>

<style lang="scss" scoped src="../styles/_link-nav-tab.scss" />
